import React, { useEffect, useState } from "react";
import { Switch, Route, useRouteMatch, Link } from "react-router-dom";

// API
import * as ChannelDto from "../api/models/ChannelDto";
import * as TransactionDto from "../api/models/TransactionDto";
import * as ChannelApi from "../api/apis/ChannelApi";

// Components
import VenueDetailLayout from "../layouts/Venues/VenueDetail";
import VenueListLayout from "../layouts/Venues/VenueList";
import BookingDetailLayout from "../layouts/Venues/BookingDetail";
import AlertComponent from "../components/Common/Alert";

import * as Utils from "../utils";
import { Alert } from "../models/alert";

interface RouteParams {
  channelid: string;
}

const Portal: React.FC<any> = (props: any) => {
  const [channel, setChannel] = useState<ChannelDto.ChannelDto>();
  let routeParams = useRouteMatch<RouteParams>("/:channelid");
  let channelId: string | undefined = routeParams != null ? routeParams.params.channelid : undefined;
  const [acceptedTransaction, setAcceptedTransaction] = useState<TransactionDto.TransactionDto>();
  const [alert, setAlert] = useState<Alert>();
  
  // Get Channel
  useEffect(() => {
    channelId &&
      new ChannelApi.ChannelApi()
        .getChannel({ channelId: channelId })
        .then((response) => {
          setChannel(response.item);
        })
        .catch((response) => {
          Utils.showError(setAlert, response);
        });
  }, [channelId]);

  return (
    <div>
      {channel?.cssUrl && channel.cssUrl !== undefined && (
        <link rel="stylesheet" href={channel?.cssUrl ?? ""} />
      )}

      <nav className="shadow-sm navbar-light bg-white p-3 recintes-header">
        <Link to={"/" + channelId}>
          <img
            className="mx-auto d-block"
            alt={channel?.name ?? ""}
            height="40"
          />
        </Link>
      </nav>

      <div className="Container">
        <AlertComponent setAlert={setAlert} alert={alert} />

        <Switch>
          <Route exact path="/:channelid/:venueid/confirmBooking">
            <BookingDetailLayout 
              acceptedTransaction={acceptedTransaction} 
              setAlert={setAlert}
            />
          </Route>

          <Route exact path="/:channelid/:venueid">
            <VenueDetailLayout
              setAlert={setAlert}
              setAcceptedTransaction={setAcceptedTransaction}
            />
          </Route>

          <Route exact path="/:channelid">
            <VenueListLayout 
              setAlert={setAlert} 
            />
          </Route>
        </Switch>
      </div>

      <div
        className="normal-text"
        style={{
          backgroundColor: "#e0e0e0",
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
          textAlign: "right",
          padding: 5,
          zIndex: 99999,
        }}
      >
        Powered by{" "}
        <a
          className="normal-text"
          href="https://www.fila12.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={require("../assets/img/fila12.png")}
            alt="Fila 12"
            style={{ width: 25, height: 25 }}
          />
        </a>
      </div>
      
    </div>
  );
};

export default Portal;
